import React from 'react';
import { Box, Container, Grid, Typography, Button, Paper } from '@mui/material';
import { Link } from 'react-router-dom';
import BlogSidebar from '../components/BlogSidebar';
import { blogPosts } from '../data/blogData';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import PersonIcon from '@mui/icons-material/Person';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';

const NewsAndUpdatesScreen = () => {
    return (
        <Box sx={{ bgcolor: '#f5f5f5', py: 8, minHeight: '100vh' }}>
            <Container maxWidth="lg">
                <Grid container spacing={4}>
                    {/* Main Content */}
                    <Grid item xs={12} md={8}>
                        {blogPosts.map((post) => (
                            <Paper key={post.id} elevation={0} sx={{ p: 4, mb: 4, borderRadius: 0 }}>
                                <Link to={`/news-and-updates/${post.slug}`} style={{ textDecoration: 'none' }}>
                                    <Typography variant="h4" sx={{ color: '#333', fontWeight: 'bold', mb: 2, '&:hover': { color: '#007bff' } }}>
                                        {post.title}
                                    </Typography>
                                </Link>

                                <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 2, mb: 3, color: '#888', fontSize: '13px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <CalendarTodayIcon sx={{ fontSize: '14px', mr: 0.5 }} />
                                        {post.date}
                                    </Box>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <PersonIcon sx={{ fontSize: '16px', mr: 0.5 }} />
                                        By {post.author}
                                    </Box>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <FolderOpenIcon sx={{ fontSize: '16px', mr: 0.5 }} />
                                        {post.category}
                                    </Box>
                                </Box>

                                {post.imageUrl && (
                                    <Box sx={{ mb: 3 }}>
                                        <img src={post.imageUrl} alt={post.title} style={{ width: '100%', height: 'auto', display: 'block' }}
                                            onError={(e) => { e.target.style.display = 'none'; }} />
                                    </Box>
                                )}

                                <Typography sx={{ color: '#555', lineHeight: 1.8, mb: 3 }}>
                                    {post.excerpt}
                                </Typography>

                                <Link to={`/news-and-updates/${post.slug}`} style={{ textDecoration: 'none' }}>
                                    <Button variant="outlined" sx={{
                                        borderColor: '#ddd',
                                        color: '#555',
                                        textTransform: 'uppercase',
                                        borderRadius: 0,
                                        px: 3,
                                        '&:hover': { borderColor: '#007bff', color: '#007bff', bgcolor: 'transparent' }
                                    }}>
                                        Read More
                                    </Button>
                                </Link>
                            </Paper>
                        ))}
                    </Grid>

                    {/* Sidebar */}
                    <Grid item xs={12} md={4}>
                        <BlogSidebar />
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default NewsAndUpdatesScreen;
